// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"LabeledText_wrapper__1hea1","title":"LabeledText_title__1IRvz","content":"LabeledText_content__2SHAS"};